import { useState } from "react";
import Select from "./Select";

## Basic Usage

export function BasicSelect() {
  const [value, setValue] = useState("");
  return (
    <Select
      options={[
        { value: "apple", label: "Apple" },
        { value: "banana", label: "Banana" },
        { value: "cherry", label: "Cherry" },
        { value: "date", label: "Date" },
      ]}
      value={value}
      onChange={setValue}
      placeholder="Select a fruit..."
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <BasicSelect />
</div>

---

## Sizes

<div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "300px" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Medium:**</p>
    <Select
      selectSize="medium"
      options={[
        { value: "1", label: "Option 1" },
        { value: "2", label: "Option 2" },
      ]}
      placeholder="Medium select"
    />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Large (default):**</p>
    <Select
      selectSize="large"
      options={[
        { value: "1", label: "Option 1" },
        { value: "2", label: "Option 2" },
      ]}
      placeholder="Large select"
    />
  </div>
</div>

---

## With Groups and Headers

export function GroupedSelect() {
  const [value, setValue] = useState("");
  return (
    <Select
      value={value}
      onChange={setValue}
      placeholder="Select an item..."
      options={[
        { value: "", label: "Fruits", displayBehavior: "header" },
        { value: "apple", label: "Apple" },
        { value: "banana", label: "Banana" },
        { value: "", label: "", displayBehavior: "ruler" },
        { value: "", label: "Vegetables", displayBehavior: "header" },
        { value: "carrot", label: "Carrot" },
        { value: "broccoli", label: "Broccoli" },
      ]}
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <GroupedSelect />
</div>

---

## Disabled State

<div style={{ maxWidth: "300px" }}>
  <Select
    disabled
    value="selected"
    options={[{ value: "selected", label: "Selected option" }]}
    title="This field is disabled"
  />
</div>

---

## Locked State

<div style={{ maxWidth: "300px" }}>
  <Select
    lockIcon
    value="locked"
    options={[{ value: "locked", label: "Locked value" }]}
    title="This value cannot be changed"
  />
</div>

---

## With Disabled Options

export function DisabledOptions() {
  const [value, setValue] = useState("");
  return (
    <Select
      value={value}
      onChange={setValue}
      placeholder="Select an option..."
      options={[
        { value: "available", label: "Available" },
        { value: "unavailable", label: "Unavailable (disabled)", displayBehavior: "disabled" },
        { value: "locked", label: "Locked option", displayBehavior: "locked" },
        { value: "another", label: "Another available" },
      ]}
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <DisabledOptions />
</div>

---

## Indented Hierarchy

export function IndentedSelect() {
  const [value, setValue] = useState("");
  return (
    <Select
      value={value}
      onChange={setValue}
      placeholder="Select a location..."
      options={[
        { value: "division", label: "Division", indent: 0 },
        { value: "community", label: "Community", indent: 1 },
        { value: "phase", label: "Phase", indent: 2 },
        { value: "", label: "", displayBehavior: "ruler" },
        { value: "other", label: "Other Division", indent: 0 },
      ]}
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <IndentedSelect />
</div>

---

## With Tooltip

<div style={{ maxWidth: "300px" }}>
  <Select
    showTooltip
    tooltipText="Select your preferred option"
    options={[
      { value: "1", label: "Option with a very long label that might get truncated" },
      { value: "2", label: "Another option" },
    ]}
    placeholder="Hover to see tooltip"
  />
</div>

---

## Country Selector Example

export function CountrySelector() {
  const [country, setCountry] = useState("");
  return (
    <div>
      <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>Country</label>
      <Select
        value={country}
        onChange={setCountry}
        placeholder="Select your country..."
        options={[
          { value: "us", label: "United States" },
          { value: "uk", label: "United Kingdom" },
          { value: "ca", label: "Canada" },
          { value: "au", label: "Australia" },
          { value: "de", label: "Germany" },
          { value: "fr", label: "France" },
          { value: "jp", label: "Japan" },
        ]}
      />
    </div>
  );
}

<div style={{ maxWidth: "300px" }}>
  <CountrySelector />
</div>


